import templateUrl from "emun.customer/customer-container-full.htm";
import controller from "emun.customer/customer-container.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
